export default __webpack_public_path__ + "static/sign-2ebcb64f6fe8a04a6ca90ee7d08d55f2.webp";